"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcCloseIconButton = void 0;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var AcCloseIconButton = function (_a) {
    var route = _a.route, onClickX = _a.onClickX, center = _a.center;
    var history = react_router_dom_1.useHistory();
    var onClick = function (e) {
        if (onClickX) {
            e.stopPropagation();
            onClickX();
        }
        else if (route) {
            history.push(route);
        }
        else {
            history.goBack();
        }
    };
    return (react_1.default.createElement("div", { onClick: onClick, className: "p-2 fs-20 text-secondary sortable-ignore " + (center ? 'd-inline-flex align-items-center' : 'd-inline-block'), style: { cursor: 'pointer' } },
        react_1.default.createElement("i", { className: "far fa-times fs-18" })));
};
exports.AcCloseIconButton = AcCloseIconButton;
exports.AcCloseIconButton.displayName = 'AcCloseIconButton';
//# sourceMappingURL=AcCloseIconButton.js.map